
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifistrengt4Google as ObiWifistrengt4GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifistrengt-4-google.js';
 
 
 

 
 export const ObiWifistrengt4Google = createComponent({
   react: React,
   tagName: 'obi-wifistrengt-4-google',
   elementClass: ObiWifistrengt4GoogleElement,
   events: {
     
   }
  });
 
 